import { createContext, useContext, useEffect, useState } from 'react';
import { getSiteConfig } from '@/lib/api';

const DEFAULT_CONFIG = {
  booking_url: 'https://booksy.com',
  phone: '571-351-8282',
  email: 'artificially_intelligent@lxratech.com',
  instagram_handle: '@lxrastudios',
  instagram_url: 'https://instagram.com/lxrastudios',
  service_area: 'DMV (Washington DC, Maryland & Virginia)',
  studio_name: 'LXRA Studios',
};

const SiteConfigContext = createContext(DEFAULT_CONFIG);

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);

  useEffect(() => {
    let mounted = true;
    getSiteConfig()
      .then((data) => {
        if (mounted) setConfig((prev) => ({ ...prev, ...data }));
      })
      .catch(() => {
        // keep defaults silently — non-critical for rendering
      });
    return () => {
      mounted = false;
    };
  }, []);

  return <SiteConfigContext.Provider value={config}>{children}</SiteConfigContext.Provider>;
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
